import {
  PUT_REDUX_SERVICE_LEVEL_QUOTE, PUT_REDUX_SERVICE_LEVEL_CODE, PUT_REDUX_SERVICE_LEVEL_APPROVED,
  ADD_PAGE_LOADER, REMOVE_PAGE_LOADER,
} from '../../reducers/constants';

export const putReduxServiceLevelQuotes = (serviceLevelQuotes) => ({
  type: PUT_REDUX_SERVICE_LEVEL_QUOTE,
  serviceLevelQuotes,
});

export const putReduxServiceLevelCode = (serviceLevelCode) => ({
  type: PUT_REDUX_SERVICE_LEVEL_CODE,
  serviceLevelCode,
});

export const addPageLoader = () => ({
  type: ADD_PAGE_LOADER,
});
export const removePageLoader = () => ({
  type: REMOVE_PAGE_LOADER,
});

export const putReduxServiceLevelApproved = (serviceLevelApproved) => ({
  type: PUT_REDUX_SERVICE_LEVEL_APPROVED,
  serviceLevelApproved,
});
